import { createSelector } from 'redux-bundler';
import _ from 'lodash';
import TreeviewPanel from './tree-view-panel';
import LayerSubpanel from './layer-subpanel/layer-subpanel';

export default {
  name: 'treeview',

  getReducer(){
    const initialState = {
      rootNodeCreated: false,
      configLayersLoaded: false,
      shouldRenderDetails: false,
      selectedItem: null
    }

    return (state = initialState, { type, payload }) => {

      if(type === 'TREEVIEW_ROOT_CREATED'){
        return Object.assign({}, state, {
          rootNodeCreated: true
        })
      }

      if(type === 'TREEVIEW_LOADED'){
        return Object.assign({}, state, {
          configLayersLoaded: true
        })
      }

      if(type === 'TREEVIEW_DETAILS_PICKED'){
        return Object.assign({}, state, payload);
      }

      if(type === 'TREEVIEW_DETAILS_DISPLAYED'){
        return Object.assign({}, state, payload);
      }

      return state;
    }
  },

  doTreeCreateRootNode: () => ({dispatch, store}) => {
    dispatch({type:'TREEVIEW_ROOT_CREATED'});
    store.doAddLayer({
      id: 'treeview-root',
      root: true,
      leaf: false,
      teamDatasetId: null,
      collapsed: false,
      visible: false,
      sortOrder: 0,
      displayName: 'Root',
      type: 'Folder'
    })
  },

  doTreeLoadDefaultLayers: () => ({dispatch, store}) => {
    dispatch({type: 'TREEVIEW_LOADED'})
    const params = store.selectWindowLocationParams();
    const turnOn = !params.layers ? [] : params.layers.split(',').map(Number);
    const layers = store.selectDefaultLayers();
    const sortedLayers = _.orderBy(layers, ['parentId', 'layerOrder'], ['desc', 'asc']);
    sortedLayers.forEach((lyr) => {
      if(lyr.parentId){
        const idMap = store.selectIdMap();
        lyr.parentUid = idMap[lyr.parentId]
      }else{
        lyr.parentUid = store.selectTreeViewRootId()
      }
      if(lyr.teamDatasetId && turnOn.indexOf(lyr.teamDatasetId) !== -1){
        lyr.visible = true;
      }
      store.doAddLayer(lyr);
    })
  },

  doRenderTreeView: () => ({dispatch, store}) => {
    store.doOpenPrimaryPanel({
      openedBy: 'LayerTree',
      children: [ TreeviewPanel ]
    })
  },

  doOpenLayerDetails: (item) => ({dispatch, store}) => {
    dispatch({type: 'TREEVIEW_DETAILS_PICKED', payload: { shouldRenderDetails: true, selectedItem: item }});
  },

  doRenderLayerDetails: () => ({dispatch, store}) => {
    dispatch({type: 'TREEVIEW_DETAILS_DISPLAYED', payload: { shouldRenderDetails: false }});
    store.doOpenPrimaryPanel({
      openedBy: 'LayerTree',
      children:[ LayerSubpanel ]
    })
  },

  selectTreeRootNode: createSelector(
    'selectLayers',
    'selectTreeViewRootId',
    (layers, uid) => {
      return Object.assign({}, layers[uid]);
    }
  ),

  selectTreeViewRootId: createSelector(
    'selectIdMap',
    (idMap) => {
      return idMap['treeview-root'];
    }
  ),

  selectTreeViewSelectedItem: (state) => {
    return state.treeview.selectedItem;
  },

  reactCreateRootNode: (state) => {
    if(!state.treeview.rootNodeCreated) return {actionCreator: 'doTreeCreateRootNode'};
  },

  reactLoadLayersFromConfig: (state) => {
    if(state.treeview.rootNodeCreated && !state.treeview.configLayersLoaded) return { actionCreator: 'doTreeLoadDefaultLayers'};
  },

  reactShouldRenderLayerDetails: (state) => {
    if(state.treeview.shouldRenderDetails) return { actionCreator: 'doRenderLayerDetails' };
  }
}